<script setup>
import { useAccount } from 'dashboard/composables/useAccount';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['click']);
const { isOnChatwootCloud } = useAccount();

const onClick = () => {
  emit('click');
};
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <FeatureSpotlight
      :title="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
      :note="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
      fallback-thumbnail="/assets/images/dashboard/captain/assistant-light.svg"
      fallback-thumbnail-dark="/assets/images/dashboard/captain/assistant-dark.svg"
      learn-more-url="https://chwt.app/hc/captain-tools"
      class="!rounded-xl !border !border-solid !border-auth-border !bg-auth-surface dark:!border-auth-border-dark dark:!bg-auth-surface-dark [&_button]:focus-visible:!outline-auth-action dark:[&_button]:focus-visible:!outline-auth-accent"
      :hide-actions="!isOnChatwootCloud"
    />
    <EmptyStateLayout
      :title="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.TITLE')"
      :subtitle="$t('CAPTAIN.CUSTOM_TOOLS.EMPTY_STATE.SUBTITLE')"
      :action-perms="['administrator']"
      :show-backdrop="false"
      class="min-h-80 flex-1 rounded-xl border border-dashed border-auth-border bg-auth-surface px-6 dark:border-auth-border-dark dark:bg-auth-surface-dark [&>div]:!min-h-80 [&>div]:!max-h-none [&>div>div]:!justify-center [&>div>div]:!pb-0 [&_.mt-48]:!mt-0"
    >
      <template #empty-state-item>
        <div class="min-h-[600px]" />
      </template>
      <template #actions>
        <Button
          :label="$t('CAPTAIN.CUSTOM_TOOLS.ADD_NEW')"
          icon="i-lucide-plus"
          class="!bg-auth-action !text-white hover:!bg-auth-action-hover focus-visible:!outline-auth-action dark:!bg-auth-accent dark:!text-auth-brand dark:hover:!bg-auth-accent-hover dark:focus-visible:!outline-auth-accent"
          @click="onClick"
        />
      </template>
    </EmptyStateLayout>
  </div>
</template>
